import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import TopbarNav from './TopbarNav';

export default function Topbar() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 h-16 glass border-b border-border">
      <div className="flex items-center justify-between h-full px-6 lg:px-8 max-w-screen-2xl mx-auto">
        <Link href="/" className="flex items-center gap-2.5 group">
          <AppLogo size={32} />
          <span className="font-semibold text-lg tracking-tight text-foreground group-hover:text-primary transition-colors duration-200">
            SurveyTrack
          </span>
          <span className="hidden sm:inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-primary/20 text-primary border border-primary/30 ml-1">
            Internal
          </span>
        </Link>

        <TopbarNav />
      </div>
    </header>
  );
}